import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['evaluation'],
        systemName: '考评系统',
    };
};
export const evaluationToPathNameMap = {
    evaluation4001: ({ businessKey }) => commonFunc(`/evaluate/scoring/target-detail?id=${businessKey}`),
};
